import styled, {css} from 'styled-components'

export const StyledGrid = styled.div(
    ({theme: {spacing}}) => css`
        display: grid;
        width: 100%;
        grid-template-columns: 1fr 1fr 32px;
        grid-template-rows: repeat(6, auto);
        align-items: center;
        gap: ${spacing * 3}px;
    `
)

export const StyledIcfCodeCell = styled.div(
    ({theme: {spacing}}) => css`
        display: grid;
        grid-template-columns: 12px 1fr;
        gap: ${spacing * 3}px;
    `
)
